/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const debounce = (func, threshold, execAsap) => (function() {
  let timeout;
  const obj = this;
  const args = arguments;

  const delayed = function() {
    let timeout;
    if (!execAsap) {
      func.apply(obj, args);
    }

    return timeout = null;
  };

  if (timeout) {
    clearTimeout(timeout);
  } else if (execAsap) {
    func.apply(obj, args);
  }

  return timeout = setTimeout(delayed, threshold || 100);
});

jQuery.fn["smartresize"] = function(fn) {
  if (fn) {
    return this.bind("resize", debounce(fn));
  } else {
    return this.trigger("smartresize");
  }
};
